import { AxiosPromise } from 'axios';
import { IGetSteps, ICourse, IGetCourse, IGetCourses } from '../models/courses.model';
import axios from 'axios';

const uri = '/mgmt/courses';

export const getSteps = (): AxiosPromise<IGetSteps> => {
  return axios.get(uri);
}

export const getSteps2 = (eduStepCode: string): AxiosPromise<IGetSteps> => {
  return axios.get(`${uri}/${eduStepCode}/list`);
};

export const getCourse = (id: string): AxiosPromise<IGetCourse> => {
  return axios.get(`${uri}/${id}`);
}

export const getCourses = (): AxiosPromise<IGetCourses> => {
  return axios.get(`${uri}/course-details`);
}

export const createCourse = (data: ICourse): AxiosPromise => {
  return axios.post(`${uri}/course-details`, data);
};

export const updateCourse = (id: string, data: ICourse): AxiosPromise => {
  return axios.put(`${uri}/course-details/${id}`, data);
};
